module.exports = __webpack_public_path__ + "static/lights26-841c99f24ee54d33e236ad86f59b3fcc.jpg";